import { useDispatch, useSelector } from 'react-redux';
import { useCallback, useState } from 'react';

import { Page } from '@distribute/shared/types';
import { pagesModel } from '../../../features/pages';
import { workspaceModel } from '../../../features/workspace';

export const usePageActions = () => {
  const dispatch = useDispatch();

  const pages = useSelector(pagesModel.selectors.selectPages);

  const [currentPage, setCurrentPage] = useState<Page | null>(null);

  const [isDeletePageModalOpen, setIsDeletePageModalOpen] = useState(false);
  const [isMovePageToFolderModalOpen, setIsMovePageToFolderModalOpen] =
    useState(false);
  const [isSharePageModalOpen, setIsSharePageModalOpen] = useState(false);

  const onDeletePageOpen = useCallback(
    (id: string) => {
      setCurrentPage(pages.find((p) => p.id === id) as Page);
      setIsDeletePageModalOpen(true);
    },
    [pages]
  );

  const onDeletePageClose = () => {
    setCurrentPage(null);
    setIsDeletePageModalOpen(false);
  };

  const onMoveToFolderOpen = useCallback(
    (id: string) => {
      setCurrentPage(pages.find((p) => p.id === id) as Page);
      setIsMovePageToFolderModalOpen(true);
    },
    [pages]
  );

  const onMoveToFolderClose = () => {
    setCurrentPage(null);
    setIsMovePageToFolderModalOpen(false);
  };

  const handleSharePage = useCallback(
    (id: string) => {
      const page = pages.find((p) => p.id === id) as Page;

      if (page) {
        dispatch(
          workspaceModel.actions.setConversionToolsData({
            documentId: page?.content.id,
          })
        );
        dispatch(pagesModel.actions.setCurrentPage(page));
        setIsSharePageModalOpen(true);
      }
    },
    [dispatch, pages]
  );

  const handleSharePageClose = () => {
    setIsSharePageModalOpen(false);
    dispatch(pagesModel.actions.setCurrentPage());
  };

  return {
    currentPage,
    isDeletePageModalOpen,
    isMovePageToFolderModalOpen,
    isSharePageModalOpen,
    onDeletePageOpen,
    onDeletePageClose,
    onMoveToFolderOpen,
    onMoveToFolderClose,
    handleSharePage,
    handleSharePageClose,
  };
};
